import React, { Component } from 'react';

import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom'

class privacypolicy extends Component {
  render() {

    return (
        <div>
           
            <div className="section_padding">

               <div className="container section_container">
               <div className="section_head text-center">
<h2>Deepforge AI Privacy Policy 
</h2>
<p></p>
</div>
    <div className="privcypolicy">
    <p>Deepforge AI Private Limited aka Deepforge AI (“We”) are committed to protecting and  respecting your privacy. </p>
    <p>This policy (together with our Terms and Conditions and any other documents referred to on  it) sets out the basis on which any personal data we collect from you or that you provide to us  will be processed by us. Please read the following carefully to understand our views and  practices regarding your personal data and how we will treat it. By visiting <a href="https://dfaibeta.site/">www.deepforgeai.com</a>, you are accepting and consenting to the practices described in this  policy. 
</p>
<p>For the purpose of the Information Technology Act, 2000 (“Act”) of India, the data controller  is Deepforge AI Private Limited aka Deepforge AI of 1-65/15, G.Begumpet, Madhapur,  Hyderabad, Telangana, India. 500081. 
</p>
<p>If you have any queries regarding our use of your data or this policy, or you would like to  make a request to exercise any of your legal rights, please refer to the contact information  below. 
</p>
<h5>INFORMATION WE MAY COLLECT FROM YOU </h5>
<p>
We may collect and process the following data about you: 
<ul>
  <li><h6>Information you give us.</h6>
  <ul>
    <li><p>You may give us information by filling in forms on our  
site deepforgeai.com (the Site) or by corresponding with us by phone, e-mail,  or otherwise. This includes information you provide when you register to use  our site, subscribe to our service(s), participate in discussion boards or other  social media functions on our site, enter a competition, promotion, or survey,  submit contact details, job application, or signup for email newsletters, and  when you report a problem with our site. The information you give us may include your name, address, e-mail address and phone number, job title, or the  company of employment.</p> </li>
<li><p>If you fail to provide personal data which We need to provide the Service then  We may not be able to perform the contract We have with You. You are  responsible for ensuring that the personal data which you give us is accurate  and up to date.</p> </li>
  </ul>
  </li>
  <li><h6>Information we collect about you.</h6><ul>
  <li>
  We may automatically collect certain technical information from your  computer or mobile device when you visit deepforgeai.com. This technical  information consists of: Your internet protocol address, your browser type,  your operating system, the pages you view on the Site, and the search terms  you enter on the Site. This information allows us to improve the Site and the  services we provide and enables us to evaluate usage of the Site, compile  statistical reports on Site activity, and facilitate the delivery of information on  the Site or other websites. 
  </li>
  <li>We may also collect, use, and share “Aggregated Data,” such as statistical or  demographic data for any purpose. Aggregated data may be derived from your 
personal data but is not considered personal data in law as this data does not  directly or indirectly reveal your identity.
</li>
<li>We do not collect any “Special Categories of Personal Data” about you (e.g.  your race, ethnicity, religious or philosophical beliefs, sex life, sexual  
orientation, political opinion, trade union membership, information about your  health, and genetic and biometric data). Nor do we collect information about  criminal convictions and offenses. 
</li>
<li>We do not collect data regarding children, and our service is not aimed at or  intended for the use of anyone below the age of 18 years old (see our Terms  and Conditions). </li>
</ul></li>
<li><h6>Information we receive from other sources.</h6><ul>
  <li>
  We collect technical data from the following: Analytics providers such as  Google Analytics, LinkedIn, Active Campaign, Salesforce, and LeadFeeder  based inside and outside India. 

  </li>
  <li>We don’t currently use any automated decision making to profile the  information and data received through our site. 
</li>

</ul></li>
</ul>

</p>
<h5>COOKIES  </h5>
<p>Cookies are small text files that are sent to your browser to help us provide a better user  experience. We use cookies to store user preferences, optimize user experience, understand  how users interact with the site, and provide users with personalized content.</p>
<p>
We use the following cookies:
<ul>
  <li><h6>Google Tag Manager</h6>
  <p className="mb-0">Used to analyze website usage, e.g., Clicks, downloaded  content, etc 
</p>
  </li>
  <li><h6>Google</h6>
  <p >Used to send data to Google Analytics about the user’s device and behaviour and track the user across devices and for marketing. </p>
  </li>
  <li><h6>Cookie Notice</h6>
  <p>Stores the user’s cookie consent state for deepforgeai.com</p>
  </li>
  <li><h6>Hotjar</h6>
  <p>Used to optimize the user’s experience across our website.</p>
  </li>
  <li><h6>Dotdigital</h6>
  <p>Provides us with insights regarding keywords used to reach our website  and to analyze our traffic.</p>
  </li>
  <li><h6>SEMRush</h6>
  <p>Provides us with insights regarding keywords used to reach our website  and to analyze our traffic.</p>
  </li>
  </ul>
  </p>
<h5>DISCLOSURE OF YOUR INFORMATION 
</h5>
<p>We may share your personal information with any group member (both inside and outside of  India), which means our subsidiaries, our ultimate holding company, and its subsidiaries, as  defined in Companies Act, 2013 of India's Parliament. </p>
<p>We may share your information with selected third parties, including
<ul>
  <li><p> Business partners, suppliers, and sub-contractors for the performance of any contract  we enter into with them or you. </p></li>
  <li><p>Advertisers and advertising networks require the data to select and serve relevant  adverts to you and others such as: Facebook, LinkedIn, Twitter, and Google Display  Network.</p> </li>
 
 <li><p>Analytics, search engine providers, and social media platforms help us improve and  optimize our site.</p></li>
<li><p>Regulatory due diligence concerning regulated services you buy from us, which may  involve personal data checks.</p></li> 
</ul>

</p>
<p>We may disclose your personal information to third parties: 
  <ul>
    <li>
      <p>If we sell or buy any business or assets, in which case we may disclose your personal  data to the prospective seller or buyer of such business or assets. </p>
    </li>
    <li>
      <p>If Deepforge AI Private Limited or substantially all of its assets are acquired by a  third party, in which case personal data held by it about its customers will be one of  the transferred assets. </p>
    </li>
    <li>
      <p>If we are under a duty to disclose or share your personal data in order to comply with  any legal obligation, or in order to enforce or apply our <Link to="/terms-and-conditions">terms of use</Link> and other  agreements; or to protect the rights, property, or safety of Deepforge AI Private  Limited (including our subsidiaries, our ultimate holding company and its  subsidiaries, Companies Act, 2013 of the Parliament of India.), our customers, or  others. This includes exchanging information with other companies and organizations  for the purposes of fraud protection and credit risk reduction. </p>
    </li>
    <li><p>
    In the business's legitimate interests, such as business planning, risk management, and  crime prevention.
      </p></li>
  </ul>
</p>
<h5>WHERE WE STORE YOUR PERSONAL DATA </h5>
<p>The data that we collect from you may be transferred to and stored at, a destination outside  India. 
</p>
<p>[e.g., All information you provide to us is stored on our secure servers. Any payment  transactions will be encrypted using SSL technology. Where we have given you (or where  you have chosen) a password which enables you to access certain parts of our site, you are  responsible for keeping this password confidential. We ask you not to share a password with  anyone. 
</p>
<p>Unfortunately, the transmission of information via the internet is not completely secure. We  will do our best to protect your personal data. We cannot guarantee the security of your data  transmitted to our site; any transmission is at your own risk. Once we have received your  information, we will use strict procedures and security features to prevent unauthorized  access. 
</p>
<p>We will not keep your personal data for longer than is necessary for the purpose or purposes  for which they are collected or as is legally required. We will take all reasonable steps to  destroy or erase all data from our systems, which is no longer required. </p>
<h5>CONTACT </h5>
<p>We endeavour to process all personal data in line with your DPA rights. In particular, In  certain circumstances, you have the rights to:
  <ul><li><p>Withdraw your consent to Our processing of your personal data at any time. You can  do this at any time by contacting us at <a href="mailto:privacy@deepforgeai.com">privacy@deepforgeai.com</a>.</p></li>
  <li><p>Ask us to rectify inaccurate or incomplete personal data.</p></li>
  <li><p>Ask us to erase your personal data.</p></li>
  <li><p>Restrict the processing of your personal data where, for example, the data is  inaccurate, being processed unlawfully, or where the data is no longer relevant to the  specific purpose for processing. 
</p></li>
  <li><p>Request access to your personal data via a subject access request.</p></li>
  <li><p>You have the right to ask us not to process your personal data for marketing purposes  (including profiling). You can also exercise the right at any time by contacting us at  <a href="mailto:privacy@deepforgeai.com">privacy@deepforgeai.com</a>. </p></li>
  <li><p>Obtain and reuse your personal data for your own purposes across different services  (right to data portability). </p></li>
  </ul>
</p>
<p>From time to time, our site may contain links to and from the websites of Our partner  networks, advertisers, and affiliates. If you follow a link to any of these websites, please note  that these websites have their own privacy policies. We do not accept any responsibility or  liability for these policies. Please check these policies before You submit any personal data to  these websites. 
</p>
<h5>CHANGES TO OUR PRIVACY POLICY</h5>
<p>Any changes we may make to this Privacy Policy in the future will be posted on this page </p>
<h5>CONTACT AND COMPLAINTS</h5>
<p>If You have any questions, comments, or requests regarding this Privacy Policy, please  contact Us:</p>
<p>Email address: <a href="mailto:privacy@deepforgeai.com">privacy@deepforgeai.com</a> </p>
<p>Postal address: 1-65/15, G.Begumpet, Madhapur, Hyderabad, Telangana, India. 500081 If you have any complaints regarding our handling of your personal data, we would  appreciate the chance to deal with your concerns directly.
</p>
    </div>
               {/* policy */}
           
       </div>
</div>
               {/* call to actin */}
           
               </div>
           
       
        );
    }
  }
  
  export default privacypolicy;